import { render, staticRenderFns } from "./TodaysMenu.vue?vue&type=template&id=ddc76e28&scoped=true"
import script from "./TodaysMenu.vue?vue&type=script&lang=js"
export * from "./TodaysMenu.vue?vue&type=script&lang=js"
import style0 from "./TodaysMenu.vue?vue&type=style&index=0&id=ddc76e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc76e28",
  null
  
)

export default component.exports